// Dependency-free site constants (safe to import from tooling/tests).

export const SITE_URL = 'https://procuralerts.com'
export const APP_REGISTER_URL = 'https://app.procuralerts.com/register'
export const APP_LOGIN_URL = 'https://app.procuralerts.com/login'
export const CONTACT_EMAIL = 'hello@procuralerts.com'
